import React from 'react'
import Prop from '../componentes/Prop'
import { ICON_TYPES } from '../constantes/iconos.ts'
import styled from 'styled-components'
import { Icon } from '@iconify/react/dist/iconify.js'
import { req } from '../listas/requerimentos.js'
import Titulo from '../componentes/Titulo.jsx'

const Serviciosocial = () => {
    return (
        <>
            <Prop titulo='SERVICIO SOCIAL' icono={ICON_TYPES.SERVICIO} />
            <Section>
                <Article>
                    <Primero>
                        <h3>¿QUIERES REALIZAR TU SERVICIO SOCIAL CON NOSOTROS?</h3>
                    </Primero>
                    <Respuesta>
                        <p> Solo debes comunicarte con nosotros y entregarnos los siguientes documentos</p>
                    </Respuesta>
                    <Container>
                        {req.map(element => {
                            return (
                                <Ficha key={element.titulo} >
                                    <h4>{element.titulo}</h4>
                                    <Circulo>
                                        <Icon icon={'tabler:number-0-small'} style={{ fontSize: '100px' }} />
                                        <Icon icon={`tabler:number-${element.icono}-small`} style={{ fontSize: '100px' }} />
                                    </Circulo>
                                </Ficha>
                            )
                        })
                        }

                    </Container>
                </Article>
            </Section>
            <Section>
                <Article style={{ backgroundColor: 'var(--secundary)' }}>
                    <Titulo titulo='Contáctanos' color='white' />
                    <Container>
                        <button style={{ color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent', flexDirection: 'column' }} >
                            <a style={{ backgroundColor: 'transparent' }} href="https://wa.link/o8yhic">
                                <Icon icon={'stash:social-whatsapp-solid'} style={{ fontSize: '100px' }} />
                            </a>
                            <span>+57 312 2465330</span>
                        </button>
                        <div style={{ color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent', flexDirection: 'column' }} >
                            <Icon icon={'material-symbols:mail-sharp'} style={{ fontSize: '100px' }} />
                            <span>jfundacionmeda@gmail.com</span>
                        </div>
                    </Container>
                </Article>
            </Section>
        </>
    )
}

const Section = styled.section`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px 0;
`
const Article = styled.article`
    width: max(70%, 300px);
    height: max-content;
    background-color: var(--primary);
    border-radius: 20px;
    padding: 30px;
`
const Primero = styled.div`
    width: 80%;
    height: 100px;
    border-radius: 0 20px 20px 0;
    background-color: var(--secundary);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 10px #eee;
    padding: 10px;
`

const Respuesta = styled.div`
    width: 80%;
    height: max-content;
    border-radius: 20px 0 0 20px;
    background-color: var(--secundary);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 20px 20%;
    padding: 20px;
    box-shadow: 0 4px 10px #eee;

`
const Container = styled.div`
    width: 80%;
    height: max-content;
    margin: 20px 10%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
`

const Ficha = styled.div`
    padding: 15px;
    margin: 20px 0;
    width: max(20vw, 200px);
    height: 100px;
    border-radius: 20px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--secundary);
    color: white;
    box-shadow: 0 4px 10px #fff;
`

const Circulo = styled.div`
    position: absolute;
    bottom:0;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    border: 1px solid black;
    box-shadow: 0 -4px 10px #eee;
    transform: translateY(50%);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--secundary);
    padding: 2px;
    color: white;
    gap: 0;
`

export default Serviciosocial